/* eslint-disable no-restricted-imports */
import FavouriteToggle from '~/client/components/Game/GameView/GameViewDesktop/GameBlock/GameHeader/FavouriteToggle';
import useIsLoggedIn from '~/client/hooks/user/useIsLoggedIn';
import BackButtonClick from './MobileGamePageNavBarButtons/BackButtonClick';
import GameCurrencySelect from '../../GameCurrencySelect';
import GameCurrency from '../../GameCurrencySelect/useGameCurrencySelect/GameCurrency';
import GameHeaderButton from '../GameHeaderButton';

type Props = {
  gameCurrencySelect: GameCurrency;
  translations: Record<string, string>;
};

const MobileGamePageNavBar: FC<Props> = ({
  translations,
  gameCurrencySelect,
}) => {
  const isLoggedIn = useIsLoggedIn();

  return (
    <div className="relative my-0 mx-auto flex h-full w-full items-center justify-between py-4 2xl:max-w-[99rem]">
      <BackButtonClick />
      <div className="flex items-center gap-2">
        {isLoggedIn && (
          <GameHeaderButton className="border-beerus">
            <FavouriteToggle />
          </GameHeaderButton>
        )}
        <GameCurrencySelect
          gameCurrencySelect={gameCurrencySelect}
          translations={translations}
        />
      </div>
    </div>
  );
};

export default MobileGamePageNavBar;
